import { Dropdown } from "primereact/dropdown";
import React from "react";
import { Message } from "primereact/message";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Growl } from "primereact/growl";

import servicioObjetos from '../servicio/ServicioObjetos';
import servicioFormatos from '../servicio/ServicioFormatos';
import servicioHttp from "../servicio/ServicioHttp";
import servicioAsignacionValoresObjetos from "../servicio/ServicioObjetos";
import { CALENDARIO_ES_MX, FORMATO_FECHA_CALENDAR } from '../servicio/ServicioConstantes';
import servicioArchivos from '../servicio/ServicioArchivos';
const TODOS = { label: "Todos", value: 0 };


const JOIN_PRINCIPAL = {
    "tcTrabajador": "alias_tcTrabajador",
    "ttLoteSolicitudIdse": "alias_ttLoteSolicitudIdse",
    "alias_ttLoteSolicitudIdse.tcEmpresa": "alias_tcEmpresa"
};

const JOIN_TABLA_INSIDENCIA ={
    "tcTrabajador": "alias_tcTrabajador",
    "tcEmpresa": "alias_tcEmpresa"

}
export class ExportaSua extends React.Component {

    constructor() {
        super();
        this.state = {
            consulta: {},
            registrosPatronales: [],
            registroPatronal: null,
            tipoMovimiento: null,
            errores: {},
            tipoDeMovimientos: [
                { label: "Seleccionar", value: null },
                { label: "Archivo de trabajadores", value: 0 },
                { label: "Archivo de movimientos", value: 1 },
                { label: "Archivo de movimientos ausentismos e incapacidades", value: 2}
            ],
            mostrarCalendarios: true,
            idsenube: 0,
            paginacion: {
                registrosPorPagina: 10,
                registrosTotales:0,
                join: null,
                restriccionesDinamicas: [
                ]
            },
        };
    }

    componentDidMount() {
        this.obtenerRegistrosPatronales();
    }
    asignarRestriccionesIncidencia=()=>{
        let { consulta, paginacion, registrosPatronales,registroPatronal } = this.state;
        paginacion.join = JOIN_TABLA_INSIDENCIA;
        paginacion.restriccionesDinamicas = [];

        if (!servicioObjetos.esObjetoVacio(consulta.registroPatronal)) {
            console.log(consulta.registroPatronal);
            if (registroPatronal !== 0) {
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "eq",
                    nombrePropiedad: "alias_tcEmpresa.id",
                    valorPropiedad: registroPatronal
                });
            } else {
                let empresasUsuarioSesion = [];
                for (let index = 0; index < registrosPatronales.length; index++) {
                    let elemento = registrosPatronales[index];
                    if (elemento.value !== 0) {
                        let valor = elemento.value;
                        empresasUsuarioSesion.push(
                            valor
                        );
                    }
                }
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "in",
                    nombrePropiedad: "alias_tcEmpresa.id",
                    coleccionIn: empresasUsuarioSesion
                });
            }
        }
        if (!servicioObjetos.esObjetoVacio(consulta.fechaInicial) && !servicioObjetos.esObjetoVacio(consulta.fechaFinal)) {
            let fechaIncial = servicioFormatos.formatearFechaString(consulta.fechaInicial);
            let fechaFinal = servicioFormatos.formatearFechaString(consulta.fechaFinal);
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "between",
                nombrePropiedad: "fecha",
                valorPropiedad: null,
                fechaIncialBetween: fechaIncial,
                fechaFinalBetween: fechaFinal
            });
        }

    }

    asignarRestricciones =() =>{
        let { consulta, paginacion, registrosPatronales,registroPatronal, tipoMovimiento } = this.state;
        paginacion.join = JOIN_PRINCIPAL;
        paginacion.restriccionesDinamicas = [];
        if (!servicioObjetos.esObjetoVacio(consulta.registroPatronal)) {
            console.log(consulta.registroPatronal);
            if (registroPatronal !== 0) {
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "eq",
                    nombrePropiedad: "alias_tcEmpresa.id",
                    valorPropiedad: registroPatronal
                });
            } else {
                let empresasUsuarioSesion = [];
                for (let index = 0; index < registrosPatronales.length; index++) {
                    let elemento = registrosPatronales[index];
                    if (elemento.value !== 0) {
                        let valor = elemento.value;
                        empresasUsuarioSesion.push(
                            valor
                        );
                    }
                }
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "in",
                    nombrePropiedad: "alias_tcEmpresa.id",
                    coleccionIn: empresasUsuarioSesion
                });
            }
        }
        if (!servicioObjetos.esObjetoVacio(consulta.fechaInicial) && !servicioObjetos.esObjetoVacio(consulta.fechaFinal)) {
            let fechaIncial = servicioFormatos.formatearFechaString(consulta.fechaInicial);
            let fechaFinal = servicioFormatos.formatearFechaString(consulta.fechaFinal).replace('00:00:00', '23:59:59');
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "between",
                nombrePropiedad: "fechaMovimientoDate",
                valorPropiedad: null,
                fechaIncialBetween: fechaIncial,
                fechaFinalBetween: fechaFinal
            });
        }
       if(tipoMovimiento===0){
        paginacion.restriccionesDinamicas.push({
            tipoRestriccion: "eq",
            nombrePropiedad: "tipoMovimiento",
            valorPropiedad: "08"
            });
       }
       paginacion.restriccionesDinamicas.push({
        tipoRestriccion: "eq",
        nombrePropiedad: "estadoRespuesta",
        valorPropiedad: 0
        });
        paginacion.restriccionesDinamicas.push({
            tipoRestriccion: "isNotNull",
            nombrePropiedad: "alias_ttLoteSolicitudIdse.fechaRespuesta",
            
            });

        paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "isNull",
                nombrePropiedad: "descripcionError",
                
                });

        paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "isNull",
                    nombrePropiedad: "descripcionErrorAfil",
                    
                    });

    }
    consultaMovimientos = () => {
        this.asignarRestricciones();
        let { paginacion, consulta, tipoMovimiento } = this.state;
        if(tipoMovimiento === 0){
            let fechaIncial = servicioFormatos.formatearFechaString(consulta.fechaInicial).replace('00:00:00', '');
            let fechaFinal = servicioFormatos.formatearFechaString(consulta.fechaFinal).replace('00:00:00', '');
         servicioArchivos.descargaArchivo('movimientos/genera_archivo_trabajadores.json', {paginacionWrapper:paginacion,fechaInicial:fechaIncial,fechaFinal:fechaFinal });
        }
         if(tipoMovimiento === 1){
            let fechaIncial = servicioFormatos.formatearFechaString(consulta.fechaInicial).replace('00:00:00', '');
            let fechaFinal = servicioFormatos.formatearFechaString(consulta.fechaFinal).replace('00:00:00', '');
            servicioArchivos.descargaArchivo('movimientos/genera_archivo_movimientos.json', {paginacionWrapper:paginacion,fechaInicial:fechaIncial,fechaFinal:fechaFinal });
         }
         if(tipoMovimiento===2){
        this.asignarRestriccionesIncidencia();
         servicioArchivos.descargaArchivo('incidencia/generar_sua_paginacion.json',paginacion);
         }
        }

    obtenerRegistrosPatronales = () => {
        servicioHttp.consumirPostHttp('empresa/obtener_registro_patronal.json').then(response => {
            let registrosPatronales = [TODOS];
            var newArray = registrosPatronales.concat(response.data.lista);
            let { consulta } = this.state;
            consulta.registroPatronal = TODOS;
            this.setState({ registrosPatronales: newArray, consulta: consulta });
        }).catch(error => {

        });
    };

    asignarValores = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, false);
    };

    buscar() {
        let { registroPatronal, tipoMovimiento, consulta ,paginacion} = this.state;
        paginacion.numeroPagina = 0;
        const validacion = this.validarFormulario(registroPatronal, tipoMovimiento, consulta);
        this.setState({ errores: validacion });
        if (!Object.keys(validacion).length) {
            this.asignarRestricciones();
            this.consultaMovimientos();            
        }
    }

    validarFormulario = (registroPatronal, tipoMovimiento, objeto) => {
        const errores = {};
        if (servicioObjetos.esObjetoVacio(registroPatronal))
            errores.registroPatronal = "Seleccione Registro Patronal";
        if (servicioObjetos.esObjetoVacio(tipoMovimiento))
            errores.tipoMovimiento = "Seleccione un movimiento";
        if (servicioObjetos.esObjetoVacio(objeto.fechaInicial))
            errores.fechaInicial = "Seleccione Fecha Inicial";
        if (servicioObjetos.esObjetoVacio(objeto.fechaFinal))
            errores.fechaFinal = "Seleccione Fecha FInal";
        return errores;
    }

    reiniciarFrmBusqueda = () => {
        this.setState({
            consulta: {},
            registroPatronal: null,
            tipoMovimiento: null,
            mostrarCalendarios: false,
            fecha: {},
            errores: {}
        });
        setTimeout(() => {
            this.setState({ mostrarCalendarios: true });
        }, 50);
        this.obtenerRegistrosPatronales();
    }

    render() {

        let { errores, mostrarCalendarios, registrosPatronales, consulta, tipoDeMovimientos } = this.state;

        let calendarioInicial =
            <div className="p-col-12 p-md-4">
                <Calendar
                    id="consulta.fechaInicial"
                    name="consulta.fechaInicial"
                    value={consulta.fechaInicial}
                    placeholder="*Fecha Inicial"
                    onChange={(e) => this.asignarValores(e, false)}
                    className={errores.fechaInicial ? 'p-error' : ''}
                    dateFormat={FORMATO_FECHA_CALENDAR}
                    locale={CALENDARIO_ES_MX} />
                {errores.fechaInicial ? <div><br /> <Message severity="error" text={errores.fechaInicial} /> </div> : null}
            </div>;

        let calendardioFinal =
            <div className="p-col-12 p-md-4">
                <Calendar
                    id="consulta.fechaFinal"
                    name="consulta.fechaFinal"
                    value={consulta.fechaFinal}
                    placeholder="*Fecha Final"
                    onChange={(e) => this.asignarValores(e, false)}
                    className={errores.fechaFinal ? 'p-error' : ''}
                    dateFormat={FORMATO_FECHA_CALENDAR}
                    locale={CALENDARIO_ES_MX} />
                {errores.fechaFinal ? <div><br /> <Message severity="error" text={errores.fechaFinal} /> </div> : null}
            </div>;

        return (

            <div className="p-grid">
                <Growl ref={(el) => (this.growl = el)} />
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <h1>Exportación al SUA</h1>
                        <div className="p-fluid p-grid">
                            <div className="p-col-12 col-md-12">
                                
                            </div>

                            <div className="p-col-12 p-md-2">
                                <label>*Registro Patronal:</label>
                            </div>
                            <div className="p-col-12 p-md-5">
                                <Dropdown
                                    filter={true} filterPlaceholder="Filtra por RP o Nombre corto" filterBy="value,label" showClear={true}
                                    id="consulta.registroPatronal"
                                    name="consulta.registroPatronal"
                                    options={registrosPatronales}
                                    value={this.state.registroPatronal}
                                    onChange={(event) => this.setState({ registroPatronal: event.value })}
                                    placeholder="Todos" />
                                {errores.registroPatronal ? (<div><br /> <Message severity="error" text={errores.registroPatronal} />{" "}</div>) : null}
                            </div>

                            <div className="p-col-12 p-md-12">
                                <label></label>
                            </div>

                            <div className="p-col-12 p-md-2">
                                <label>*Tipo de Movimiento:</label>
                            </div>
                            <div className="p-col-12 p-md-5">
                                <Dropdown
                                    id="consulta.tipoMovimiento"
                                    name="consulta.tipoMovimiento"
                                    options={tipoDeMovimientos}
                                    value={this.state.tipoMovimiento}
                                    onChange={(event) => this.setState({ tipoMovimiento: event.value })} />
                                {errores.tipoMovimiento ? (<div><br /> <Message severity="error" text={errores.tipoMovimiento} />{" "}</div>) : null}
                            </div>

                            <div className="p-col-12 p-md-12">
                                <label></label>
                            </div>

                            <div className="p-col-12 p-md-2">
                                <label>*Fecha:</label>
                            </div>
                            <div className="p-col-12 p-md-1">
                                <label>entre</label>
                            </div>
                            {mostrarCalendarios ? calendarioInicial : null}
                            <div className="p-col-12 p-md-1">
                                <center><label >y</label></center>
                            </div>
                            {mostrarCalendarios ? calendardioFinal : null}

                            <div className="p-col-12 col-md-12">
                                <label></label>
                            </div>

                            <div className="p-col-12 p-md-3">
                                <label></label>
                            </div>
                            <div className="p-col-12 p-md-3">
                                <Button
                                    label="Limpiar"
                                    icon="pi-md-refresh"
                                    onClick={this.reiniciarFrmBusqueda} />
                            </div>
                            <div className="p-col-12 p-md-3">
                                <Button
                                    label="Buscar"
                                    icon="pi-md-search"
                                    onClick={this.buscar.bind(this)} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}